import React, { useState, useEffect } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import Sidebar from "../common/sidebar";
import { BaseUrl } from "../common/config";
import { http } from "../helper";
import CKEditor from "ckeditor4-react";
import { useNavigate } from "react-router-dom";
import ShowAlert from "../common/Showalert";
import CommonAlert from "../common/Commonalert";
import { useLocation } from "react-router-dom";
import RichTextEditor from "../common/richTextEditor";
//import { canAction } from "../common/permissionhelper";
//const MODULE = "manage_emailcampaign";
import EmailDynamicContentInfo from "../common/emailDynamicContentInfo";
import { t } from "i18next";
import { RESTRICTED_EMAIL_TYPES } from "../common/constants";
const EditEmailConfig = () => {
  // Permission checks
  //const canEdit = canAction(MODULE, "edit");
  //const isReadOnly = !canEdit; // if true, disable inputs and hide submit
  const location = useLocation();
  const navigate = useNavigate();
  const emailTypes = [
    { name: t("customer_intro_email_txt"), value: "customer_intro" },
    { name: t("logged_in_ordered_email_txt"), value: "logged_in_not_order" },
    {
      name: t("logged_in_ordered_email_cutoff_txt"),
      value: "logged_in_not_order_cutoff",
    },
    { name: t("abandoned_cart_email_txt"), value: "abandoned_cart" },
  ];
  const [availableEmailTypeOptions, setAvailableEmailTypeOptions] =
    useState(emailTypes);
  const [emailTemplateData, setEmailTemplateData] = useState(
    location.state?.templateData
  );
  useEffect(() => {
    if (!emailTemplateData) return;
    if (RESTRICTED_EMAIL_TYPES.includes(emailTemplateData.emailType)) {
      // Block editing restricted template
      navigate("/email-configuration", { replace: true });
    }
  }, [emailTemplateData]);

  const [isCustomInterval, setIsCustomInterval] = useState(false);
  const [customInterval, setCustomInterval] = useState("");
  const [emailTemplateList, setEmailTemplateList] = useState([]);
  const [errors, setErrors] = useState({});
  const [alertPopup, setAlertPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertErrorPopup, setAlertErrorPopup] = useState(false);
  const [alertErrorMessage, setAlertErrorMessage] = useState("");
  console.log(location.state?.templateData, "location.state?.templateData");

  if (!sessionStorage.getItem("isLoggedIn")) {
    window.location.href = "/"; // redirect to login if not logged in
  }
  if (
    JSON.parse(sessionStorage.getItem("authData")) !== "" &&
    !JSON.parse(
      sessionStorage.getItem("authData")
    ).adminRole.permissions.includes("manage_emailcampaign")
  ) {
    window.location.href = "/unauthorized"; // no permission, go to unauthorized page
  }
  console.log(emailTemplateData, "emailTemplateData");
  useEffect(() => {
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }

    let URL = BaseUrl + `admin/emailConfigs`;
    http
      .get(URL)
      .then((response) => {
        let responseData = response.data.data || [];
        // remove restricted types
        const filteredData = responseData.filter(
          (item) => !RESTRICTED_EMAIL_TYPES.includes(item.emailType),
        );
        setEmailTemplateList(filteredData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (
      emailTemplateData?.reminderInterval &&
      ![24, 48, 96].includes(emailTemplateData.reminderInterval)
    ) {
      setIsCustomInterval(true);
      setCustomInterval(emailTemplateData.reminderInterval);
    }
  }, []);

  useEffect(() => {
    if (emailTemplateList.length === 0) return;
    const usedTypes = new Set(
      emailTemplateList
        .filter((t) => t.emailType !== emailTemplateData.emailType) // ❗ skip current
        .map((t) => t.emailType)
    );
    setAvailableEmailTypeOptions(
      emailTypes.filter(
        (opt) =>
          !usedTypes.has(opt.value) &&
          !RESTRICTED_EMAIL_TYPES.includes(opt.value),
      ),
    );
  }, [emailTemplateList]);

  const routeChange = () => {
    navigate("/email-configuration");
  };

  const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  const formvalidation = () => {
    const errmsg = {};
    let isValid = true;
    console.log(emailTemplateData, "emailTemplateData");
    // for (const [key, value] of Object.entries(emailTemplateData)) {
    //      if (typeof value === "string" && stripHtml(value).trim() === "") {
    //         isValid = false;
    //         errmsg[key]= "This field is required" ;
    //     }
    // }
    if (!emailTemplateData.templateName.trim()) {
      errmsg.templateName = t("field_require_txt");
      isValid = false;
    }
    if (!emailTemplateData.emailType.trim()) {
      errmsg.emailType = t("field_require_txt");
      isValid = false;
    }
    if (!emailTemplateData.emailSubject.trim()) {
      errmsg.emailSubject = t("field_require_txt");
      isValid = false;
    }
    if (!stripHtml(emailTemplateData.emailContent).trim()) {
      errmsg.emailContent = t("field_require_txt");
      isValid = false;
    }
    // Conditional fields (only for logged_in_not_order and abandoned_cart)
    if (
      emailTemplateData.emailType === "logged_in_not_order" ||
      emailTemplateData.emailType === "abandoned_cart" ||
      emailTemplateData.emailType === "logged_in_not_order_cutoff"
    ) {
      if (
        !emailTemplateData.reminderCountLimit ||
        isNaN(emailTemplateData.reminderCountLimit)
      ) {
        errmsg.reminderCountLimit = t("field_require_txt");
        isValid = false;
      }
      // ✅ Handle reminder interval dropdown and custom input separately
      if (isCustomInterval) {
        // Custom selected
        if (
          customInterval === "" ||
          isNaN(customInterval) ||
          parseInt(customInterval, 10) <= 0
        ) {
          errmsg.customReminderInterval = t("field_require_txt");
          isValid = false;
        }
      } else {
        if (
          !emailTemplateData.reminderInterval ||
          isNaN(emailTemplateData.reminderInterval)
        ) {
          errmsg.reminderInterval = t("field_require_txt");
          isValid = false;
        }
      }
      if (!emailTemplateData.reminderEmailSubject.trim()) {
        errmsg.reminderEmailSubject = t("field_require_txt");
        isValid = false;
      }
      if (!stripHtml(emailTemplateData.reminderEmailContent).trim()) {
        errmsg.reminderEmailContent = t("field_require_txt");
        isValid = false;
      }
    }
    const hasDupicateEntry = emailTemplateList
      .filter((dataa) => dataa._id != emailTemplateData.id)
      .some(
        (template) =>
          template.templateName.toLowerCase() ===
          emailTemplateData.templateName.trim().toLowerCase()
      );

    if (hasDupicateEntry) {
      var alertmsg = "";
      alertmsg = t("email_config_duplicate_txt");
      setAlertErrorMessage(alertmsg);
      setAlertErrorPopup(true);
      isValid = false;
    }
    setErrors(errmsg);
    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // if (isReadOnly) return;
    const isValid = formvalidation();
    if (isValid) {
      const payload = emailTemplateData;

      console.log(payload);
      let URL = BaseUrl + `admin/editEmailConfig`;
      http
        .put(URL, payload)
        .then((response) => {
          if (response.data.success) {
            const currentEmailType = emailTypes.find(
              (item) => item.value === emailTemplateData.emailType
            );

            setAlertMessage(
              t("emailconfig_update_sucess_txt", {
                emailType: currentEmailType.name,
              })
            );
          } else {
            setAlertMessage(t("something_went_wrongs_txt"));
          }
          setAlertPopup(true);
          //   setTimeout(() => {
          //     routeChange();
          //   }, 2000);
        })
        .catch((error) => {
          console.error("Save failed", error);
          setAlertErrorMessage(t("update_alert_error_txt"));
          setAlertErrorPopup(true);
        });
    }
  };

  // const handleChangeEmailContent =(name,value) =>{
  //     setEmailTemplateData(prev => ({ ...prev, [name]: value }));
  //     setErrors(prevErrors => ({
  //         ...prevErrors,
  //         [name]: "",
  //     }));
  // }

  const handleChangeEmailContent = (value) => {
    setEmailTemplateData((prev) => ({ ...prev, emailContent: value }));
    setErrors((prev) => ({ ...prev, emailContent: "" }));
  };

  const handleChangeReminderEmailContent = (value) => {
    setEmailTemplateData((prev) => ({ ...prev, reminderEmailContent: value }));
    setErrors((prev) => ({ ...prev, reminderEmailContent: "" }));
  };

  const handleOnChange = (e) => {
    console.log(e);
    const name = e.target.name;
    const value = e.target.value;

    setEmailTemplateData((prev) => ({ ...prev, [name]: value }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleIntervalChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    const numberValue = value === "" ? "" : parseInt(value, 10); // single number
    setEmailTemplateData((prev) => ({ ...prev, [name]: numberValue }));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const handleOnCheck = (value, field) => {
    console.log(value, field);
    setEmailTemplateData((prev) => ({ ...prev, [field]: value }));
  };

  const formatHoursToDays = (hours) => {
    if (!hours || isNaN(hours)) return "";
    const totalHours = parseInt(hours, 10);
    const days = Math.floor(totalHours / 24);
    const remaining = totalHours % 24;
    let result = "";
    if (days > 0) {
      result += `${days} day${days > 1 ? "s" : ""}`;
    }
    if (remaining > 0) {
      if (result) result += " ";
      result += `${remaining} hour${remaining > 1 ? "s" : ""}`;
    }
    return result || "0 hours";
  };
  // let loadingClass = isLoading ? 'loading-buffer' : '';
  return (
    <section className="dashboard-block">
      {alertPopup && <CommonAlert title={t("alert_txt")} message={alertMessage} />}
      {alertErrorPopup && (
        <ShowAlert title={t("alert_txt")} message={alertErrorMessage} />
      )}
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          <div className="container account-details">
            <div className="right-table-outer-wrap">
              <h1 className="checkout-title">
                
                  { t("edit_email_config_title_txt")}
                  
              </h1>
              {/* <div className="form-field freeproduct-fieldset masterentry-fieldset form-container-xs"> */}
              <form className="sectors-detail-form">
                <div className="flex-bx-wrap col2">
                  <div className="flex-bx-item">
                    <div className="input-field">
                      <label for="name">{t("template_name_txt")}</label>
                      <input
                        type="text"
                        name="templateName"
                        value={emailTemplateData.templateName}
                        onChange={handleOnChange}
                        // readOnly={isReadOnly}
                      />
                      {errors.templateName && (
                        <div className="error-msg">{errors.templateName}</div>
                      )}
                    </div>
                  </div>
                  <div className="flex-bx-item">
                    <div className="input-field">
                      <label for="emailType">{t("email_type_txt")}</label>
                      <select
                        name="emailType"
                        onChange={(e) => {
                          // if (isReadOnly) return;
                          handleOnChange(e);
                        }}
                        // disabled={isReadOnly}
                        value={emailTemplateData.emailType}
                      >
                        <option value="">{t("select_txt")}</option>
                        {availableEmailTypeOptions.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                      {errors.emailType && (
                        <div className="error-msg">{errors.emailType}</div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="input-field">
                  <label for="name">{t("email_subject_txt")}</label>
                  <input
                    type="text"
                    name="emailSubject"
                    value={emailTemplateData.emailSubject}
                    onChange={handleOnChange}
                    // readOnly={isReadOnly}
                  />
                  {errors.emailSubject && (
                    <div className="error-msg">{errors.emailSubject}</div>
                  )}
                </div>
                <div className="input-field col-2">
                  <label for="name">{t("included_txt")}</label>
                  <div className="full-text-toggle custom_check-box">
                    <div className="check-box">
                      <>
                        <input
                          type="checkbox"
                          id="header"
                          checked={emailTemplateData.header} // controlled value
                          onChange={(e) => {
                            // if (isReadOnly) return;
                            handleOnCheck(e.target.checked, "header");
                          }}
                        />
                        <label htmlFor="header">{t("add_header_txt")}</label>
                        &nbsp;&nbsp;&nbsp;
                      </>
                      <>
                        <input
                          type="checkbox"
                          id="footer"
                          checked={emailTemplateData.footer} // controlled value
                          onChange={(e) => {
                            // if (isReadOnly) return;
                            handleOnCheck(e.target.checked, "footer");
                          }}
                        />
                        <label htmlFor="footer">{t("add_footer_txt")}</label>
                      </>
                    </div>
                  </div>
                </div>
                <div className="input-field">
                  <label for="name">{t("email_content_txt")}</label>
                  <EmailDynamicContentInfo
                    emailType={emailTemplateData.emailType}
                  />
                  <br />
                  <div className="email-editor-wrapper">
                    <RichTextEditor
                      emailContent={emailTemplateData.emailContent}
                      handleChangeEmailContent={handleChangeEmailContent}
                      // readOnly={isReadOnly}
                    />
                  </div>
                  {errors.emailContent && (
                    <div className="error-msg">{errors.emailContent}</div>
                  )}
                </div>

                {(emailTemplateData.emailType === "logged_in_not_order" ||
                  emailTemplateData.emailType === "abandoned_cart" ||
                  emailTemplateData.emailType ===
                    "logged_in_not_order_cutoff") && (
                  <>
                    <br />
                    <div className="flex-bx-wrap col3">
                      <div className="flex-bx-item">
                        <div className="input-field">
                          <label htmlFor="reminderCountLimit">
                            {t("reminder_limit_txt")}
                          </label>

                          <input
                            type="text"
                            name="reminderCountLimit"
                            value={emailTemplateData.reminderCountLimit}
                            placeholder={t("reminder_limit_text")}
                            min="1"
                            onKeyDown={(e) => {
                              if (
                                !/[0-9]/.test(e.key) &&
                                  ![
                                    "Backspace",
                                    "Delete",
                                    "ArrowLeft",
                                    "ArrowRight",
                                    "Tab",
                                  ].includes(e.key)
                                ) {
                                    e.preventDefault();
                                  }
                            }}
                            onChange={handleIntervalChange}
                            // readOnly={isReadOnly}
                          />
                          {errors.reminderCountLimit && (
                            <div className="error-msg">
                              {errors.reminderCountLimit}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="flex-bx-item">
                        <div className="input-field">
                          <label htmlFor="reminderInterval">
                            {t("reminder_email_interval_txt")}
                            {/* {emailTemplateData.reminderInterval > 23 && (
                          <span className="note-text">
                            {" - "}
                            {formatHoursToDays(emailTemplateData.reminderInterval)}
                          </span>
                        )} */}
                          </label>
                          {/* Dropdown */}
                          <select
                            name="reminderIntervalDropdown"
                            value={
                              isCustomInterval
                                ? "custom"
                                : emailTemplateData.reminderInterval || ""
                            }
                            onChange={(e) => {
                              const val = e.target.value;
                              if (val === "custom") {
                                setIsCustomInterval(true);
                                // prefill with existing number if it’s not 24/48/96
                                setCustomInterval(
                                  ![24, 48, 96].includes(
                                    emailTemplateData.reminderInterval
                                  )
                                    ? emailTemplateData.reminderInterval
                                    : ""
                                );
                                setEmailTemplateData((prev) => ({
                                  ...prev,
                                  reminderInterval: ![24, 48, 96].includes(
                                    emailTemplateData.reminderInterval
                                  )
                                    ? emailTemplateData.reminderInterval
                                    : "",
                                }));
                              } else {
                                setIsCustomInterval(false);
                                setEmailTemplateData((prev) => ({
                                  ...prev,
                                  reminderInterval:
                                    val === "" ? "" : parseInt(val, 10),
                                }));
                              }
                              setErrors((prev) => ({
                                ...prev,
                                reminderInterval: "",
                              }));
                            }}
                            // disabled={isReadOnly}
                          >
                            <option value="">{t("select_txt")}</option>
                            <option value="24">24</option>
                            <option value="48">48</option>
                            <option value="96">96</option>
                            <option value="custom">{t("custom_txt")}</option>
                          </select>
                          {!isCustomInterval && errors.reminderInterval && (
                            <div className="error-msg">
                              {errors.reminderInterval}
                            </div>
                          )}
                        </div>
                      </div>
                      {/* Show custom input only if "Custom" is selected */}
                      {isCustomInterval && (
                        <div className="flex-bx-item">
                          <div className="input-field">
                            <label>
                              {t("add_custom_hours_txt")}
                              {/* {emailTemplateData.reminderInterval > 23 && (
                                <span className="note-text">
                                  {" - "}
                                  {formatHoursToDays(
                                    emailTemplateData.reminderInterval
                                  )}
                                </span>
                              )} */}
                            </label>
                            <input
                              type="number"
                              name="reminderInterval"
                              value={customInterval}
                              placeholder={t("custom_hrs_text")}
                              min="1"
                              onKeyDown={(e) => {
                                if (["-", "+", ".", "e", "E"].includes(e.key))
                                  e.preventDefault();
                              }}
                              onChange={(e) => {
                                const val = e.target.value;
                                setCustomInterval(val);
                                setEmailTemplateData((prev) => ({
                                  ...prev,
                                  reminderInterval:
                                    val === "" ? "" : parseInt(val, 10),
                                }));
                                setErrors((prev) => ({
                                  ...prev,
                                  reminderInterval: "",
                                }));
                              }}
                              // readOnly={isReadOnly}
                            />
                            {errors.customReminderInterval && (
                              <div className="error-msg">
                                {errors.customReminderInterval}
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="input-field">
                      <label for="name">
                        {t("reminder_email_subject_txt")}
                      </label>
                      <input
                        type="text"
                        name="reminderEmailSubject"
                        value={emailTemplateData.reminderEmailSubject}
                        onChange={handleOnChange}
                        // readOnly={isReadOnly}
                      />
                      {errors.reminderEmailSubject && (
                        <div className="error-msg">
                          {errors.reminderEmailSubject}
                        </div>
                      )}
                    </div>

                    <div className="input-field col-2">
                      <label for="name">
                        {t("reminder_email_included_txt")}
                      </label>
                      <div className="full-text-toggle custom_check-box">
                        <div className="check-box">
                          <>
                            <input
                              type="checkbox"
                              id="reminderHeader"
                              checked={emailTemplateData.reminderHeader} // controlled value
                              onChange={(e) => {
                                // if (isReadOnly) return;
                                handleOnCheck(
                                  e.target.checked,
                                  "reminderHeader"
                                );
                              }}
                            />
                            <label htmlFor="reminderHeader">
                              {t("add_header_txt")}
                            </label>
                            &nbsp;&nbsp;&nbsp;
                          </>
                          <>
                            <input
                              type="checkbox"
                              id="reminderFooter"
                              checked={emailTemplateData.reminderFooter} // controlled value
                              onChange={(e) => {
                                // if (isReadOnly) return;
                                handleOnCheck(
                                  e.target.checked,
                                  "reminderFooter"
                                );
                              }}
                            />
                            <label htmlFor="reminderFooter">
                              {t("add_footer_txt")}
                            </label>
                          </>
                        </div>
                      </div>
                    </div>

                    <div className="input-field">
                      <label for="name">
                        {t("reminder_email_content_txt")}
                      </label>
                      <EmailDynamicContentInfo
                        emailType={emailTemplateData.emailType}
                      />
                      <br />
                      <div className="email-editor-wrapper">
                        <RichTextEditor
                          emailContent={emailTemplateData.reminderEmailContent}
                          handleChangeEmailContent={
                            handleChangeReminderEmailContent
                          }
                          // readOnly={isReadOnly}
                        />
                      </div>
                      {errors.reminderEmailContent && (
                        <div className="error-msg">
                          {errors.reminderEmailContent}
                        </div>
                      )}
                    </div>
                  </>
                )}

                <div className="btnfield">
                  {/* {canEdit && ( */}
                    <button
                      type="submit"
                      name="emailTemplateSubmit"
                      onClick={handleSubmit}
                    >
                      {t("submit_txt")}
                    </button>
                  {/* )} */}
                  &nbsp;&nbsp;&nbsp;
                  <button type="button" onClick={routeChange}>
                    {t("cancel_txt")}
                  </button>
                </div>
              </form>
              {/* </div> */}
            </div>
          </div>
          <Footer />
        </section>
        <Footer />
      </div>
    </section>
  );
};

export default EditEmailConfig;
